export default __webpack_public_path__ + "static/media/loginbg2.a585bf58.jpg";